module.exports = "<div toastContainer>\r\n    <router-outlet></router-outlet>\r\n</div>\r\n<ppa-footer></ppa-footer>"